import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doHandleAddBanner),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchBannerSagas);

import { delay } from 'redux-saga';
import { put, fork, takeEvery, call } from 'redux-saga/effects';
import { ADD_BANNER, removeBanner } from './Banners.reducer';
export function doHandleAddBanner(_ref) {
  var _ref$data, timeout, id;

  return regeneratorRuntime.wrap(function doHandleAddBanner$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$data = _ref.data, timeout = _ref$data.options.timeout, id = _ref$data.id;

          if (!(timeout > 0)) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return call(delay, timeout);

        case 4:
          _context.next = 6;
          return put(removeBanner(id));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function watchBannerSagas() {
  return regeneratorRuntime.wrap(function watchBannerSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, ADD_BANNER, doHandleAddBanner);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}